<!--
* 组件名 : 书籍内容
* 开发者 : JY
*
* 参数:
*   bookData         { Array } -  书籍数据
* 事件: null
*
*
-->
<template>
  <section class="book-selector">
    <div class="multiple" v-for="(item, i) in bookData" :key="i">
      <div class="attach-title" v-if="item.content === ''">
        <a :href="item.introduction_link" target="_blank">{{ item.title }}</a>
      </div>

      <div class="book-classification" v-else>
        <div class="class-box">
          <h2 class="class-title">{{ item.title }}</h2>
          <span class="sub-title">{{ item.period }}</span>
        </div>
        <div class="intro-content" v-if="item.introduction">
          <p class="intro">{{ $TL.intro }}</p>
          <div class="intro-text" v-html="item.introduction" />
          <div class="read-more">
            <a :href="item.introduction_link" target="_blank">{{
              $TL.readMore
            }}</a>
          </div>
        </div>
        <div class="lists-layout">
          <p class="catalogue">{{ $TL.directory }}</p>
          <div class="list-module" ref="listModule">
            <template v-if="is_list(item.content)">
              <article-lists :content="item.content" />
            </template>
            <template v-else>
              <sub-menus :content="item.content" />
            </template>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import articleLists from "./components/article-list/index.vue";
import subMenus from "./components/sub-menu/index.vue";
export default {
  name: "book-selector",
  props: {
    bookData: {
      type: Array,
      required: true,
    },
  },
  components: {
    articleLists,
    subMenus,
  },
  mounted() {
    this.link_target_blank();
  },
  methods: {
    /**
     * 判断是否为列表，而不是二级展开收起标题
     */
    is_list(content) {
      return content.indexOf('class="secondTitle"') > -1 ? false : true;
    },
    /**
     * 文章标题添加新窗口打开
     */
    link_target_blank() {
      $(this.$refs.listModule)
        .find(".dir a")
        .map((i, item) => item.setAttribute("target", "_blank"));
    },
  },
};
</script>

<style lang="scss">
.book-selector {
  margin-top: 78px;
  padding-bottom: 88px;
  overflow: hidden;
}

.multiple {
  a,
  p,
  span,
  strong,
  h2,
  h4 {
    color: #3a3a3a;
  }

  a {
    &:hover {
      color: $color-hover-text;
      text-decoration: underline;
    }
  }

  .attach-title {
    margin-bottom: 20px;
    a {
      font-size: 20px;
    }
  }

  .class-box {
    margin-bottom: 26px;
  }

  .class-title {
    font-size: 20px;
    margin-bottom: 12px;
  }

  .sub-title {
    color: rgba(#3a3a3a, 0.78);
  }

  .intro,
  .catalogue {
    font-size: 18px;
  }

  .intro-content {
    .intro-text {
      margin-top: 18px;
    }

    .intro-text,
    .intro-text p {
      font-size: 18px;
      line-height: 1.6;
      font-family: "source-han-serif-sc";
    }
    .intro-text p {
      &:nth-of-type(n + 2) {
        display: none;
      }
    }

    .read-more {
      text-align: center;
      margin-top: 16px;
      a {
        font-size: 18px;
        color: $color-chapter-title;
      }
    }
  }

  .lists-layout {
    margin-top: 40px;
  }

  .catalogue {
    margin-bottom: 24px;
  }

  .list-module {
    margin-bottom: 82px;
  }
}

body[data-lang="zh-TW"],
body[data-lang="zh-CN"] {
  .intro-text,
  .intro-text p {
    text-indent: 2em;
  }
}

body.latin {
  .multiple {
    .intro-content {
      .intro-text,
      .intro-text p {
        font-family: Georgia;
        @include limit-line(7, 1.5);
      }
    }
  }
}
</style>
